import type { PesquisaTipo } from '../types/pesquisaSatisfacaoTypes';

export type TomDaNota = 'erro' | 'aviso' | 'neutro' | 'sucesso';

const TOM_CSAT: Record<number, TomDaNota> = {
  1: 'erro',
  2: 'aviso',
  3: 'neutro',
  4: 'sucesso',
  5: 'sucesso',
};

const TOM_CES: Record<number, TomDaNota> = {
  1: 'erro',
  2: 'erro',
  3: 'aviso',
  4: 'neutro',
  5: 'sucesso',
  6: 'sucesso',
  7: 'sucesso',
};

export function tomDaNota(tipo: PesquisaTipo, nota: number): TomDaNota {
  const tom = tipo === 'CSAT' ? TOM_CSAT[nota] : TOM_CES[nota];
  return tom ?? 'neutro';
}

export function notaEhAlta(tipo: PesquisaTipo, nota: number): boolean {
  return tomDaNota(tipo, nota) === 'sucesso';
}
